/* istanbul ignore file */
export default () => ({
  inputWrapper: {
    marginBottom: 20
  }
});
